<script setup lang="ts"></script>

<template>
  <div>Hello! This is test homepage!</div>
</template>
